<template>
  <div class="page">
    <div
      class="card"
      :class="{ '-loading': loading }"
    >
      <loader v-if="loading"></loader>

      <div class="header">
        <div class="description">
          <h2 class="title">Convites</h2>
          <p class="subtitle"> Nesta tela você visualiza todos os convites enviados pela plataforma.</p>
        </div>

        <card-actions>
          <router-link
            :to="{ name: 'Invite-Create' }"
            class="btn btn-primary -sm"
          >
            Adicionar Usuário
            <ion-icon name="add"></ion-icon>
          </router-link>
        </card-actions>
      </div>

      <div
        class="body"
        :class="{ '-no-padding': !errors.cantLoadInviteList }"
      >
        <div class="alert -danger" v-if="errors.cantLoadInviteList">
          <p class="title">Ops!</p>

          <p>
            Infelizmente aconteceu um erro ao tentar carregar o seu histórico,
            por favor tente novamente ou contate nossa equipe.
          </p>
        </div>

        <template v-if="!errors.cantLoadInviteList">
          <table class="invite">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Empresa</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="invite in invites" :key="invite.id" v-show="invites.length > 0">
                <td>
                  <p class="block font-medium">{{ invite.name }}</p>
                  <p class="block text-xs">{{ invite.email }}</p>
                </td>
                <td>
                  <span v-if="invite.organization">
                    {{ invite.organization.name }}
                  </span>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-primary -sm"
                    @click="resend(invite.id)">
                    Reenviar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/support/components/Loader.vue';
import CardActions from '@/support/components/card/CardActions.vue';

export default {
  name: 'Index',

  data() {
    return {
      loading: false,
      errors: {
        cantLoadInviteList: false,
      },
    };
  },

  methods: {
    /**
     * Fetch the invites list.
     *
     * @returns {Promise<void>}
     */
    async fetchInviteList() {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch('invite/fetchInviteList');
      } catch {
        this.errors.cantLoadInviteList = true;
      } finally {
        this.loading = false;
      }
    },

    async resend(id) {
      try {
        this.loading = true;

        await this.$store.dispatch('invite/resendInvite', { id });

        this.$notify({
          group: 'app',
          type: 'success',
          title: 'Sucesso!',
          text: 'Convite reenviado com sucesso.',
        });
      } catch (e) {
        this.$notify({
          group: 'app',
          type: 'warning',
          title: 'Erro!',
          text: 'Falha ao reenviar convite por email.',
          duration: 5000,
        });
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the all errors to initial value.
     */
    resetErrors() {
      this.errors.cantLoadInviteList = false;
    },
  },

  computed: {
    ...mapState('invite', {
      invites: 'invites',
    }),
  },

  mounted() {
    this.fetchInviteList();
  },

  components: {
    Loader,
    CardActions,
  },
};
</script>

<style lang="scss" scoped>
.page {
  > .card {
    > .body {
      > .navHistory {
        @apply flex;
        @apply justify-center;
      }
    }
  }
}
.invite > tbody > tr:hover td {
  @apply bg-primary-50;
  @apply bg-opacity-25;
}
</style>
